import { Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivate } from '@angular/router';
import { login } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable, first, of } from 'rxjs';
import { AppState } from '../state/app.state.reducer';
const debug = Debug('aumico:NoAuthGuard');
@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
    constructor(private auth: Auth, private store: Store<AppState>) {}

    canActivate(): Observable<boolean> {
        authState(this.auth)
            .pipe(first((user) => user != null))
            .subscribe((user) => {
                if (user) {
                    debug('login success');
                    this.store.dispatch(login.success());
                }
            });

        return of(true);
    }
}
